import { render, staticRenderFns } from "./RSVP.vue?vue&type=template&id=019d157e"
import script from "./RSVP.vue?vue&type=script&lang=js"
export * from "./RSVP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports